export default __webpack_public_path__ + "static/media/footer-cats.37ae49af.webp";